import React, { useEffect } from 'react';
import { socialMediaJavaScriptSrc } from './enums';

const SocialPostTikTok = ({ model }) => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = socialMediaJavaScriptSrc.TIKTOK;
        document.getElementsByClassName('social-post__body')[0].appendChild(script);
    }, []);

    return (
        <div className='social-post__body' dangerouslySetInnerHTML={{ __html: model.body }}>
        </div>
    );
};

export default SocialPostTikTok;
